<template>
  <div class="myAddition">
    <div class="table-list">
      <div class="topData">
        <div class="dataItem">
          <span class="title">已成功增员</span>
          <div><span class="number">{{ totalNum.signedCount }}</span><span class="unit">人</span></div>
        </div>
        <div class="dataItem">
          <span class="title">本月推荐奖<img src="@/static/images/activityCenter/question.png" alt="" @click="getTips()" /></span>
          <div>
            <span class="number">{{ parseInt(totalNum.monthRecommendationAward || '0.00') }}.</span>
            <span class="number2">{{ getLastNum(totalNum.monthRecommendationAward || '0.00') }}</span>
          <span class="unit">元</span></div>
          
        </div>
        <div class="dataItem">
          <span class="title">累计推荐奖<img src="@/static/images/activityCenter/question.png" alt=""  @click="getTips()"/></span>
          <div>
            <span class="number">{{ parseInt(totalNum.recommendationAward || '0.00') }}.</span>
            <span class="number2">{{ getLastNum(totalNum.monthRecommendationAward || '0.00') }}</span>
          <span class="unit">元</span></div>
        </div>
      </div>
      <div ref="tabDom">
        <van-tabs v-model="active" @change="clickOneTypes()" :class="headerFixed?'headerFixed':''">
          <van-tab title="有意向" name="1"></van-tab>
          <van-tab title="未签约" name="2"></van-tab>
          <van-tab title="待出单" name="3"></van-tab>
          <van-tab title="已出单" name="4"></van-tab>
        </van-tabs>
      </div>
      
      <div class="statistic" v-if="active == '1'">
      <div>
        <span>今日访问：</span>
        <span class="num">{{listNum.todayVisit}}人</span>
      </div>
      <div>
        <span>本周访问：</span>
        <span class="num">{{listNum.weekVisit}}人</span>
      </div>
      <div>
        <span>累计访问：</span>
        <span class="num">{{listNum.accumulatedVisit}}人</span>
      </div>
    </div>
    <div class="second-tab-container" v-if="active == '2'">
      <ul class="second-tab">
        <li :class="{ 'actived': activeIndex === '' }" @click="clickSecondTypes('')">全部<span>({{listNum.allCount}})</span></li>
        <li :class="{ 'actived': activeIndex === '1' }" @click="clickSecondTypes('1')">待签约<span>({{listNum.unsignedCount}})</span></li>
        <li :class="{ 'actived': activeIndex === '2' }" @click="clickSecondTypes('2')">签约中<span>({{listNum.inSigningCount}})</span></li>
      </ul>
    </div>
    <div class="statistic left" v-if="active == '3'">
      <div>
        <span>总计：</span>
        <span class="num">{{listNum.total}}人</span>
      </div>
    </div>
      <van-loading v-if="listLoading && pageNo==1" size="24px" vertical>加载中...</van-loading>
      <!-- <van-pull-refresh v-else-if="list.length" v-model="refreshing" @refresh="onReferesh"> -->
        <van-list v-else-if="list.length" v-model="listLoading" :finished="finished" finished-text="没有更多了" @load="nextPage" :offset="10">
          <div v-for="(item,index) in list" :key='index' class="mindList" :class="active==1?'flexEnd':''" @click="goToDetail(item)">
            <div class="baseInfo">
              <img :src="item.icon" alt="" class="icon">
              <div class="rightInfo">
                <div class="wxName">
                  {{ item.name }}
                  <img v-if="item.workingState=='0'" src="@/static/images/activityCenter/dimission.png" class="workingState" alt="">
                  <img v-else-if="item.workingState=='2'" src="@/static/images/activityCenter/suspend.png" class="workingState" alt="">
                </div>
                <div class="time" v-if="active == '1'">
                  {{ getVisitsTime(item) }}
                </div>
                <div class="time" v-else-if="active == '2'">
                  {{ item.mobile }}
                </div>
                <div class="time" v-if="active == '3'">
                  <span>{{ item.entryTime | formatTime('YYYY-MM-DD') }}入职</span>
                </div>
                <div class="time" v-if="active == '4'">
                  <span>{{ item.orgName }}</span>
                </div>
              </div>
            </div>
            <div class="right"  v-if="active == '1'">
              第<span class="blue">{{ item.visits }}</span>次访问
            </div>
            <div class="rightBtn" :class="item.signingStatus=='1'?'':'blue'"  v-else-if="active == '2'">
              {{ item.signingStatus=='1'?'待签约':'签约中' }}
            </div>
            <div class="orgName"  v-else-if="active == '3'">
              <span>{{ item.orgName }}</span>
              <span class="rankName">{{ item.rankName }}</span>
            </div>
            <div class="recruitmentIncentive"  v-if="active == '4'">
              <div>累计贡献：<span class="num">{{ item.accumulatedRewards || 0  }}元</span></div>
              <div>本月贡献：<span class="num">{{ item.monthRewards || 0 }}元</span></div>
            </div>
          </div>
        </van-list>
      <!-- </van-pull-refresh> -->
      <div class="null" v-else-if="list.length <= 0 && !listLoading">
        <img class="null-img" src="@static/images/null.png" />
        <span class="null-text">暂无数据</span>
      </div>
    </div>
    <div class="bottom">
      <div class="btn" @click="$refs.activityShare.open()" v-if="active == '1'||active == '2'">
        立即邀请好友注册
      </div>
      <div class="btn" @click="$router.push({path:'/apps/settlement/ownAchievement',query:{type:'add'}})" v-if="active == '3'||active == '4'">
        查看更多增员业绩
      </div>
    </div>

    <!-- 分享面板 -->
    <ok-activity-share ref="activityShare" :download="false"></ok-activity-share>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { Dialog } from 'vant';
import okActivityShare from '@/components/okActivityShare';
export default {
  components:{okActivityShare},
  data(){
    return{
      userInfo:JSON.parse(localStorage.getItem('jzy_user')),
      totalNum:{},
      listNum:{},
      list:[],
      active:'1',
      refreshing: false, //下拉刷新
			finished: true, //是否完成上拉加载
      pageNo:'1',
      activeIndex:'',
      listLoading:false,
      totalNo:'',
      offsetTop: 0,
      offsetHeight: 0,
      headerFixed: false,
    }
  },

  mounted(){
    if(this.$route.query.firstType &&  dayjs(JSON.parse(this.$route.query.time)).format('YYYY-MM-DD HH:mm:ss') == dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')){
      this.active = this.$route.query.firstType
    }
    this.getTotalNum()
    this.getListNum()
    this.getList()
    // 获取吸顶元素的dom
    const tabDom = this.$refs.tabDom;
    this.offsetTop = tabDom.getBoundingClientRect().top;

    const dom = document.querySelector('.table-list');
    dom.addEventListener('scroll', this.handleScroll);
    
  },
  methods:{
    // 获取小数 保留末位0
    getLastNum(num) {
      return ("00" + ((num * 100).toFixed(2) % 100)).substr(-2);
    },
    handleScroll() {
      
      // 得到页面滚动的距离，兼容写法
      const scrollTop = document.querySelector('.table-list').scrollTop || document.body.scrollTop;
      // 判断页面滚动的距离是否大于吸顶元素的位置
      this.headerFixed =  this.offsetTop<scrollTop;
        
      },
    getVisitsTime(item){
      if(dayjs(item.visitsTime).format('YYYY-MM-DD') == dayjs(new Date()).format('YYYY-MM-DD')){
        return dayjs(item.visitsTime).format('HH:mm')
      }if(dayjs(item.visitsTime).format('YYYY') != dayjs(new Date()).format('YYYY')){
        return dayjs(item.visitsTime).format('YYYY-MM-DD')
      }else{
        return dayjs(item.visitsTime).format('MM-DD HH:mm')
      }
    },
    goToDetail(item){
      if(this.active == '4'){
        this.$app.openWeb(location.origin + `/apps/activityCenter/okApp/recruitingActivity/contributionDetail?title=${item.name+'贡献明细'}&id=${item.id}`)
      }
    },
    getTips(){
      Dialog.alert({
        message: '结算前为预计奖励，不含退保保单，结算后为实际结算的推荐奖。',
      })
    },
    clickSecondTypes(val){
      this.activeIndex =val
      this.list = []
      this.pageNo = '1'
      this.getList()
    },
    clickOneTypes(){
      this.$tools.cancelhttpRequest();
      this.activeIndex = ''
      this.list = []
      this.pageNo = '1'
      this.getList()
      this.getListNum()
    },
    //下拉刷新
		onReferesh() {
			this.refreshing = true;
			this.pageNo = 1;
			this.getList();
		},
    //上拉加{载
		nextPage() {
			if (this.pageNo == this.totalNo) {
				this.finished = true;
				return;
			}

			this.pageNo++;
			this.getList()
		},
    // 我的增员列表
    getList() {
      this.listLoading = true;
      this.$http({
        type: 'POST',
        url: '/app/okbao/userIncrease/list',
        data: {
          userId:this.userInfo.userId,
          firstType:this.active,
          secondType:this.activeIndex,
          pageNo:this.pageNo,
        }
      }).then(res => {
        this.totalNo = res.pages;
        this.listLoading = false;
        this.refreshing = false;
        
        if (res.current == 1) {
						this.list = [];
						this.customerListMap = {};
						this.indexList = [];
					}
          this.list = this.list.concat(res.data);
        if (res.current === res.pages) {
					this.finished = true;
				} else {
					this.finished = false;
				}
      }).catch(()=>{
        this.listLoading = false;
        this.refreshing = false;
        this.finished = true;
      });
    },
    // 我的增员列表统计数据
    getListNum() {
      this.$http({
        type: 'POST',
        url: '/app/okbao/userIncrease/listStatistic',
        data: {
          userId:this.userInfo.userId,
          firstType:this.active
        }
      }).then(res => {
        if (res.data) {
          this.listNum = res.data;
        }
      });
    },
    // 获取增员数据
    getTotalNum() {
      this.$http({
        type: 'GET',
        url: '/app/okbao/myUserIncrease/statistic',
        data: {
          userId:this.userInfo.userId
        }
      }).then(res => {
        if (res.data) {
          this.totalNum = res.data;
        }
      });
    },
  }

}
</script>

<style lang="scss" scoped>
.myAddition{
  height: 100vh;
  overflow: hidden;
  .topData{
    width: 690px;
    height: 154px;
    background: url('~@/static/images/activityCenter/backGround2.png');
    background-size: cover;
    margin: 30px 30px 10px 30px;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    color: #991004;
    padding: 30px 0;
    .dataItem{
      padding-left: 30px;
      &:not(:last-child){
        border-right: 1px solid #F3BB68;
      }
      .title{
        display: flex;
        justify-content: center;
        align-items: center;
        padding-right: 56px;
        img{
          width: 24px;
          height: 24px;
          margin-left: 3px;
        }
      }
      .number {
        font-size: 35px;
        color: #ff5426;
        font-weight: bold;
      }
      .number2 {
        margin-top: 4px;
        font-size: 28px;
        font-weight: bold;
        color: #ff5426;
      }
      .unit{
        font-size: 24px;
        color: #F74218;
      }
      
    }
  }
  .statistic{
    width: 690px;
    height: 80px;
    background: #F5F5F5;
    margin: 20px 30px 0 30px;
    border-radius: 10px;
    font-size: 24px;
    color: #888888;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    .num{
      color: #333333;
    }
    &.left{
      justify-content: flex-start;
      padding: 23px 30px;
    }
  }
  .bottom{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #ffffff;
    padding: 30px 30px 50px 30px;
  }
  .btn{
    width: 690px;
    height: 90px;
    background: #FF8B00;
    border-radius: 45px;
    font-weight: 600;
    font-size: 34px;
    color: #FFFFFF;
    text-align: center;
    line-height: 90px;
    
    margin: auto;
  }
  .mindList{
    margin: 0 30px;
    padding: 30px 0;
    border-bottom: 1px solid #ECECEC;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &.flexEnd{
      align-items: flex-end;
    }
    .icon{
      width: 86px;
      height: 86px;
      border-radius: 50%;
      margin-right: 14px;
    }
    .baseInfo{
      display: flex;
      .wxName{
        display: flex;
        max-width: 300px;
        align-items: center;
        .workingState{
          width: 68px;
          height: 36px;
          margin-left: 10px;
          
        }
      }
      .rightInfo{
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        font-size: 30px;
        color: #333333;
        .time{
          font-size: 26px;
          color: #999999;
        }
      }
    }
    .right{
      font-size: 26px;
      color: #999999;
      width: 170px;
      text-align: right;
      .blue{
        color: #348BFF;
      }
    }
    .rightBtn{
      width: 138px;
      height: 56px;
      line-height: 56px;
      text-align: center;
      border-radius: 10px;
      border: 1px solid #FC650B;
      color: #FC650B;
      font-size: 26px;
      &.blue{
        border: 1px solid #348BFF;
        color: #348BFF;
      }
    }
    .orgName{
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      font-size: 26px;
      max-width: 280px;
      color: #333333;
      .rankName{
        font-size: 26px;
        color: #999999;
        margin-top:10px;
      }
    }
    .recruitmentIncentive{
      width: 300px;
      font-size: 26px;
      color: #888888;
      .num{
        color: #333333;
      }

    }
  }
  .second-tab-container {

    padding: 20px 30px 0 30px;

    .second-tab {
      display: flex;


      li {
        flex: 1;
        width: 216px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        border-radius: 4px;
        font-size: 28px;
        background: #F3F3F3;
        color: #666666;
        &:not(:last-child) {
          margin-right: 20px;
        }
      }

      .actived {
        color: #FF8B00;
        background: #FFF3E5;
      }
    }
    }

  .table-list{
    height: calc(100vh - 150px);
  }
  .headerFixed{
    position: fixed;
    width: 100%;
    top: 0;
  }
}
/deep/ .van-tabs__line{
  bottom: 0;
}
</style>